export default __webpack_public_path__ + "static/media/video.7bfd2ab1.png";